import { useQueryClient } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import { DRILL_SERIES_QUERY_KEY, DRILLS_OVERVIEW_QUERY_KEY } from "./DRILLS_QUERY_KEYS";

// «Ещё серия» (`POST /api/drills/series`): новая серия после законченной. Сервер вернёт
// незаконченную, если она уже есть, поэтому повтор безопасен и ключ идемпотентности не нужен.
export const useStartSeries = () => {
  const queryClient = useQueryClient();
  return $api.useMutation("post", "/api/drills/series", {
    onSuccess: async (response) => {
      queryClient.setQueryData(DRILL_SERIES_QUERY_KEY, response);
      await queryClient.invalidateQueries({ queryKey: DRILLS_OVERVIEW_QUERY_KEY });
    },
  });
};
